import { Chip } from '@mui/material'
import { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { PrizeDrawRequestStatus } from 'types/prize-draw'

const colors: Record<PrizeDrawRequestStatus, ComponentProps<typeof Chip>['color']> = {
  accepted: 'primary',
  finished: 'success',
  inprogress: 'info',
  onhold: 'warning',
  new: 'primary',
  rejected: 'error',
}

export type RequestStatusTagProps = {
  status: PrizeDrawRequestStatus
}

export const RequestStatusTag = ({ status }: RequestStatusTagProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'prizesManagement.requestStatuses' })
  return <Chip variant="outlined" label={t(status)} color={colors[status]} />
}
